import { useCall } from '@stream-io/video-react-sdk';
import { Phone } from 'lucide-react';
import { useNavigate } from '@tanstack/react-router';
import { useVideoCallLogger } from '@/hooks/useVideoCallLogger';

export const EndCallButton = () => {
  const call = useCall();
  const navigate = useNavigate();
  const logger = useVideoCallLogger();

  return (
    <button
      type="button"
      className="w-10 h-10 bg-[#DC433B] hover:bg-[#e96962] text-red-200 rounded-full flex items-center justify-center cursor-pointer focus:outline-none focus:ring-2 focus:ring-red-300 border-0 p-0"
      onClick={async () => {
        try {
          await call?.screenShare?.disable();
          await call?.endCall();
          await call?.leave();
        } catch (error) {
          // Log the error but still navigate away
          logger.logError('call_state_logging_failed', error instanceof Error ? error.message : 'Unknown error ending call');
        } finally {
          navigate({ to: '/auth/chat' });
        }
      }}
      aria-label="End call"
    >
      <Phone className="w-5 h-5" />
    </button>
  );
};
